
import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';

import { EditorialListTitleFragment } from '@/pages/graphql/fragments/EditorialListTitle.fragment';

import { clickOnReadMore, clicksOnTitle } from '@/pages/editorial/tracking';

import BasicButton from '@/ui-components/BasicButton.vue';
import BuyBox from '@/components/buybox/BuyBox.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import TitleScoreList from '@/components/TitleScoreList.vue';

import TitleActionsProvider, { ListActionableTitle, isInWatchList } from '@/helpers/providers/title-actions-provider';

import { ObjectType } from '@/@types/graphql-types';
import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';

const Language = namespace('language');

@Component({
	name: 'ListArticleItem',
	components: {
		BasicButton,
		BuyBox,
		PictureComp,
		TitleActionsProvider,
		TitleScoreList,
	},
})
export default class ListArticleItem extends Vue {
	@Prop({ required: true }) title: EditorialListTitleFragment;

	@Language.Getter language: string;
	@Language.Getter country: string;

	readMore = false;

	get isInWatchList() {
		return isInWatchList(this.title as ListActionableTitle);
	}

	get watchlistActionLabel() {
		if (this.title.objectType === ObjectType.Movie) {
			return this.$t('WEBAPP_WATCHLIST');
		}

		return this.isInWatchList ? this.$t('WEBAPP_TRACKING') : this.$t('WEBAPP_WATCHLIST_TV_SHOW_START_TRACKING');
	}

	/* TRACKING */
	trackClicksOnTitle() {
		clicksOnTitle({
			category: 'userinteraction',
			action: 'title_clicked',
			label: 'editorial-lists',
			contexts: [new SnowplowTitleContextGraphql(this.title.objectId, this.title.objectType)],
		});
	}

	trackClickOnReadMore(target: EventTarget | null) {
		if (!target) return;

		clickOnReadMore({
			category: 'content_header',
			action: (target as HTMLInputElement).checked ? 'expanded' : 'collapsed',
		});
	}
}
